import { render } from "./settingsView.vue?vue&type=template&id=137e517c"
import script from "./settingsView.vue?vue&type=script&lang=js"
export * from "./settingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__